import { render, staticRenderFns } from "./SharedExplore.vue?vue&type=template&id=f00c8072&scoped=true&"
import script from "./SharedExplore.vue?vue&type=script&lang=js&"
export * from "./SharedExplore.vue?vue&type=script&lang=js&"
import style0 from "./SharedExplore.vue?vue&type=style&index=0&id=f00c8072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00c8072",
  null
  
)

export default component.exports